import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { GzRemoveADIntegrationWebComponent } from './component';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../utils/request';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { AD_CHANGE_EVENT } from '../setADIntegrator/component/interfaces';
import { TreeDetails } from '../../../networkTree/types';

export class RemoveADIntegrationPopUp extends NetworkBasePopUp<GzRemoveADIntegrationWebComponent> {
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: false,
  };
  protected title = translateFn('Remove Active Directory Integration?');
  protected customEventNameAfterConfirm = AD_CHANGE_EVENT;
  private adFolderEventDetails: TreeDetails;

  protected customSetup(): void {
    this.popUpContent = new GzRemoveADIntegrationWebComponent();
    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Confirm'),
      },
      {
        id: 'closeButton',
        label: translateFn('Cancel'),
      },
    ];
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    this.popUpContent.detachFormEventListeners();
    if (!this.data.targets) {
      throw new Error('Targets are not defined');
    }

    const formValue: FormGroupValue = this.popUpContent.getFormValue();
    const shouldRemoveUnmanagedValue = formValue.removeUnmanagedMachinesCheckbox;
    const integrationIdsToRemove = this.data.targets.map(record => record._id);

    try {
      await ConsoleRequest.createRequest<boolean>({
        dataProviderType: DataProviderType.EPS,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'ProtectedEntitiesEPS',
        method: 'removeAdCloudDomains',
        payload: {
          ids: integrationIdsToRemove,
          shouldRemoveUnmanaged: shouldRemoveUnmanagedValue,
        },
      });
    } catch (e) {
      console.error(e);
      this.showErrorToastNotification(translateFn('Failed to remove Active Directory Integration.'));
    }

    this.showCustomToast(translateFn('Active Directory Integration successfully removed.'));

    const companyId = this.data.targets[0]?.company?.id;
    if (!companyId) {
      console.error('No target for AD Integration removal');
      return;
    }
    const treeNodeResponse = await ConsoleRequest.createRequest<{ data: Partial<ProtectedEntity>[] }>({
      dataProviderType: DataProviderType.CORE,
      dataProviderEntity: DataProviderEntity.MODEL,
      endpoint: 'ProtectedEntitiesEPS',
      method: 'getProtectedEntityById',
      payload: {
        protectedEntityId: companyId,
        selectedFields: ['type', 'path', 'parentId'],
        page: 1,
        limit: 0,
        sort: null,
        dir: null,
        filter: [],
      },
    });

    const protectedEntity = treeNodeResponse.data[0];
    const protectedEntityTreeDetails: TreeDetails = {
      targetId: protectedEntity._id!,
      path: protectedEntity.path!,
      type: protectedEntity.type!,
      parentId: protectedEntity.parentId!,
    };

    this.adFolderEventDetails = protectedEntityTreeDetails;
  }

  protected getCustomEventDetail(): any {
    return {
      refreshTree: this.adFolderEventDetails,
    };
  }
}
